import { ErrorMessage } from "views/components/Message";
import { Form, Input, Password } from "views/components/common/Form";
import { Link, Redirect } from "react-router-dom";
import { LoginButton } from "views/components/LoginButton";
import { Spacer } from "views/components/common/Spacer";
import { useLoginWithPassword } from "state/users/hooks";
import { validateEmail } from "lib/forms";
import React, { useState } from "reactn";

export const LoginWithUsername = ({ referrer }) => {
	const [inputs, updateInputs] = useState({});
	const onChange = ({ target: { name, value } }) => {
		updateInputs((i) => ({
			...i,
			[name]: name === "email" ? value.toLowerCase() : value,
		}));
	};

	const [submit, success, loading, error] = useLoginWithPassword();

	if (success) return <Redirect to={referrer} />;

	return (
		<Form>
			<ErrorMessage error={error} />
			<Spacer rows={0.5} />
			<Input
				name="email"
				label="Correo Electrónico"
				errorMessage="Correo inválido"
				onChange={onChange}
				value={inputs.email}
				validator={validateEmail}
			/>
			<Spacer rows={1} />
			<Password
				label="Contraseña"
				name="password"
				onChange={onChange}
				value={inputs.password}
				validator={(v) => Boolean(v)}
			/>
			<Spacer rows={1} />
			<p>
				¿Olvidaste tu contraseña?{" "}
				<Link to="/recover">Recupérala aquí</Link>
			</p>
			<LoginButton
				fill="#4a90e2"
				stroke="#fff"
				label="Iniciar Sesión"
				onClick={() => submit(inputs)}
				loading={loading}
			/>
		</Form>
	);
};
